function About() {
  return (
    <>
      <h1 className="text-6xl mb-4">Github Finder</h1>
      <p className="mb-4 text-2xl font-light">
        Github finder is created using React. Tailwind and daisyui components
        are used for css and design the user interface. The application uses
        github api to search github users and display them on the screen.
      </p>
    </>
  );
}

export default About;
